import { useContext } from 'react'
import { AuthContext } from '../Contexts/AuthContext'

const useAccessToken = () => {
  const auth = useContext(AuthContext)
  return auth?.credential?.oauthAccessToken
}

export default useAccessToken
